import { CT_SEARCH_MAX_RESULT_WINDOW } from '~~/constants/commercetoolsProductSearch';

interface ProductListingPageParams {
  page: number;
  hitsPerPage: number;
}

interface ProductListingPaginationParams {
  total: number;
  hitsPerPage: number;
}

// CT can't page past its result window, so the last page can be lower than `total` suggests.
export const getProductListingLastPage = ({ total, hitsPerPage }: ProductListingPaginationParams): number =>
  Math.min(Math.ceil(total / hitsPerPage), Math.floor(CT_SEARCH_MAX_RESULT_WINDOW / hitsPerPage));

// CT rejects a negative offset or one past its result window with a 400.
export const isProductListingPageReachable = ({ page, hitsPerPage }: ProductListingPageParams): boolean =>
  Number.isInteger(page) && page >= 1 && page * hitsPerPage <= CT_SEARCH_MAX_RESULT_WINDOW;

// Page 1 stays valid without results, it is the "no results" page.
export const isProductListingPageInvalid = (
  { page, hitsPerPage, total }: ProductListingPageParams & ProductListingPaginationParams,
): boolean =>
  !isProductListingPageReachable({ page, hitsPerPage }) ||
  page > Math.max(1, getProductListingLastPage({ total, hitsPerPage }));
